/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/warenkorb-bestellblock-button/shop.warenkorb-bestellblock-button.component.ts.
 */
import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ShopViewComponent} from '../view/shop.view.component';
import {AppWarenkorbService} from '../../../../services/app.warenkorb.service';
import {Router} from '@angular/router';
import {AppEventService} from '../../../../services/app.event.service';
import {BehaviorSubject, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {AppUserService} from '../../../../services/app.user.service';

/**
 * Zweck: Beschreibt class ShopWarenkorbBestellblockButtonComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'warenkorb-bestellblock-button',
    templateUrl: 'shop.warenkorb-bestellblock-button.component.html',
    styleUrls: ['shop.warenkorb-bestellblock-button.component.scss'],
    standalone: false
})
export class ShopWarenkorbBestellblockButtonComponent implements OnInit, OnDestroy {
  @Input() viewComp: ShopViewComponent;

  artCount = new BehaviorSubject(0);

  _destroy = new Subject();

  sending = new BehaviorSubject(false);

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public wksvc: AppWarenkorbService, public router: Router, private esvc: AppEventService,
              public usvc: AppUserService) {
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    this._destroy.next(true);
    this._destroy.complete();
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.esvc.getQueue()
      .pipe(takeUntil(this._destroy)).subscribe(e => {
      if (e.name == 'gui.view_article_changed') {
        let count = 0;
        this.viewComp.actioncomps.forEach(c => {
          if (c.entry.menge > 0) {
            count++;
          }
        });
        this.artCount.next(count);
      }
    });
  }

/**
 * Beschreibt Methode addAll und ihren Rückgabevertrag.
 */
  addAll() {
    this.sending.next(true);
    setTimeout(() => {
      this.viewComp.addAll(() => {
        this.sending.next(false);
      });
    }, 100);
  }

/**
 * Beschreibt Methode addAllAndSend und ihren Rückgabevertrag.
 */
  addAllAndSend() {
    this.sending.next(true);
    setTimeout(() => {
      this.viewComp.addAll((added: boolean) => {
        this.sending.next(false);
        if (added) {
          const pid = this.wksvc.primary_warenkorb.value.id;
          this.router.navigateByUrl('/shop/warenkorb/' + pid + '/checkout');
        }
      });
    }, 100);
  }

}
